import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=9cb7f328&"
import script from "./Ecommerce.vue?vue&type=script&lang=js&"
export * from "./Ecommerce.vue?vue&type=script&lang=js&"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&id=9cb7f328&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cb7f328')) {
      api.createRecord('9cb7f328', component.options)
    } else {
      api.reload('9cb7f328', component.options)
    }
    module.hot.accept("./Ecommerce.vue?vue&type=template&id=9cb7f328&", function () {
      api.rerender('9cb7f328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/Ecommerce.vue"
export default component.exports